
const baseUrl = '/laskuri/api'
const productUrl = `${baseUrl}/product`
const recipeUrl = `${baseUrl}/recipe`
const operationUrl = `${baseUrl}/operation`


function parseJSON(response) {
  return response.json()
}





function listProducts() {
  return fetch(productUrl).then(parseJSON)
}

function getProductById(id) {
  return fetch(`${productUrl}/${id}`).then(parseJSON)
}

function listRecipes() {
  return fetch(recipeUrl).then(parseJSON)
}

function getRecipeById(id) {
  return fetch(`${recipeUrl}/${id}`).then(parseJSON)
}

function listOperations() {
  return fetch(operationUrl).then(parseJSON)
}

function getOperationById(id) {
  return fetch(`${operationUrl}/${id}`).then(parseJSON)
}



export default {
  listProducts,
  getProductById,
  listRecipes,
  getRecipeById,
  listOperations,
  getOperationById
}



// WEBPACK FOOTER //
// ./src/api/productService.js